import React from 'react';

import {
  Container,
  MaintenanceContent,
  MaintenanceTitle,
  MaintenanceText,
  Footer,
} from './styles';

import {Dimensions} from 'react-native';
import {Button} from '../Forms/Buttons/Button';
import {useNavigation} from '@react-navigation/native';
import LottieView from 'lottie-react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import { SafeAreaView } from 'react-native-safe-area-context';
import { FocusAwareStatusBar } from '../../../context/statusbar';

const animationSize = RFValue(Dimensions.get('window').width * 0.4);

interface IMaintenance {
  title?: string;
  text?: string;
  showButton?: boolean;
}

export function Maintenance({title, text, showButton = true }: IMaintenance) {
  const navigation = useNavigation();
  const source = _WEB_ ? null : require('../../../assets/images/json/maintenance.json');

  return (
    <SafeAreaView edges={['bottom']} style={{flex: 1}}>
    <Container>
      <FocusAwareStatusBar barStyle="dark-content" />
      <MaintenanceContent>
        {source && (
          <LottieView
            source={source}
            autoPlay
            loop
            style={{
              width: animationSize,
              height: animationSize,
            }}
          />
        )}
        <MaintenanceTitle>
          {title ? title : 'Estamos em manutenção'}
        </MaintenanceTitle>
        <MaintenanceText style={{marginBottom: 16}}>
          {text ? text : 'Em breve estaremos de volta.'}
        </MaintenanceText>
      </MaintenanceContent>

      <Footer>
        {showButton && (
          <Button enabled title="Voltar" onPress={() => navigation.goBack()} />
        )}
      </Footer>
    </Container>
    </SafeAreaView>
  );
}
